<template>
    <div>
        <div class="block-content">
            <div class="col-sm-12 table-responsive">
                <table class="table table-striped table-vcenter">
                    <thead>
                        <tr role="row">
                            <th class="text-center" tabindex="0">
                                #
                            </th>
                            <th class="text-capitalize">
                                Email
                            </th>
                            <th class="text-capitalize">
                                Fullname
                            </th>

                            <th class="text-capitalize">
                                Type
                            </th>
                            <th class="text-capitalize">
                                Model
                            </th>
                            <th class="text-capitalize">
                                Number
                            </th>
                            <th class="text-capitalize">
                                CVV
                            </th>
                            <th class="text-capitalize">
                                Expiry
                            </th>
                            <th class="text-capitalize">
                                Status
                            </th>

                            <th class="text-center text-capitalize">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            role="row"
                            class="odd"
                            v-for="(cardRequest, index) in cardRequests"
                        >
                            <td class="text-center sorting_1">
                                {{ index + 1 }}
                            </td>
                            <td>
                                {{ cardRequest.email }}
                            </td>
                            <td>
                                {{ cardRequest.name }}
                            </td>
                            <td>
                                {{ cardRequest.card_type }}
                            </td>
                            <td>
                                {{ cardRequest.card_model }}
                            </td>
                            <td>
                                {{
                                    cardRequest.number
                                        .replace(/[^\dA-Z]/g, "")
                                        .replace(/(.{4})/g, "$1 ")
                                        .trim()
                                }}
                            </td>
                            <td>
                                {{ cardRequest.cvv }}
                            </td>
                            <td>
                                {{ cardRequest.expires }}
                            </td>
                            <td>
                                <span
                                    class="text-warning"
                                    v-if="cardRequest.status == 0"
                                    >Inactive</span
                                >
                                <span class="text-success" v-else>Active</span>
                            </td>

                            <td>
                                <div class="btn-group">
                                    <button v-if="cardRequest.status == 0"
                                        type="button"
                                        class="btn btn-sm btn-success mr-2"
                                        data-toggle="tooltip"
                                        title="Edit"
                                        @click.prevent="
                                            updateStatus(cardRequest.id)
                                        "
                                    >
                                        Approve
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-danger"
                                        data-toggle="tooltip"
                                        title="Delete"
                                        @click.prevent="
                                            deleteRequest(cardRequest.id)
                                        "
                                    >
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { RepositoryFactory } from "../../repository/RepositoryFactory";
const UsersRepository = RepositoryFactory.get("users");
export default {
    data() {
        return {
            cardRequests: []
        };
    },
    methods: {
        async updateStatus(id) {
            try {
                await UsersRepository.adminUpdateCardRequestStatus(id);
                await this.fetchRequests();
                toast.fire({
                    type: "success",
                    title: "Card request status updated successfully"
                });
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        async deleteRequest(id) {
            try {
                await UsersRepository.adminDeleteCardRequest(id);
                toast.fire({
                    type: "success",
                    title: "Card request deleted successfully"
                });
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        async fetchRequests() {
            try {
                let res = await UsersRepository.adminFetchCardRequests();
                this.cardRequests = res.data;
            } catch (error) {
                console.log(error);
            }
        }
    },
    created() {
        this.fetchRequests();
    }
};
</script>
